import { render, staticRenderFns } from "./package-list.vue?vue&type=template&id=53a7c749&"
import script from "./package-list.vue?vue&type=script&lang=js&"
export * from "./package-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports